
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FormControl, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { SUPPORTED_COUNTRIES, CountryCode } from '@/types/regions';
import { ControllerRenderProps } from 'react-hook-form';

interface CountrySelectorProps {
  field: ControllerRenderProps<any, 'country'>;
  isLoading?: boolean;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({ field, isLoading }) => {
  return (
    <FormItem>
      <FormLabel>Country</FormLabel>
      <FormControl>
        <Select 
          onValueChange={field.onChange} 
          defaultValue={field.value}
          disabled={isLoading}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select your country" />
          </SelectTrigger>
          <SelectContent>
            {SUPPORTED_COUNTRIES.map((country) => (
              <SelectItem key={country.code} value={country.code}>
                <div className="flex items-center gap-2">
                  <span>{country.flag}</span>
                  <span>{country.name}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
